import React from "react";
import * as agent from "../agent";
import { FormattedDate, FormattedNumber, FormattedTime } from "react-intl";
import { generatePayments, calculateLeasingTotalSum, generateLeasingPayments } from "../businessLogic";
import { formatDate } from "../utility";
import InnerLink from './InnerLink';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

class SecurityPayments extends React.Component {
    state = {
        transactionsLoaded: false,
        transactions: []
    }
    componentDidMount() {
        this.fetchData();
    }
    fetchData() {
        const { contractId } = this.props;
        agent.Transactions.getByContract(contractId)
            .then(res => this.setState({
                transactions: res,
                transactionsLoaded: true
            }))
            .catch(err => alert(err.message));
    }
    render() {
        const { transactions = [], transactionsLoaded } = this.state;
        const { sum,
                rates,
                creationDate,
                sumLog = [],
                payments = [],
                duration,
                programType,
                isLeasingPrepayed,
                preferentialRepayment,
                preferentialPeriod } = this.props;
        const isLeasing = programType === "PTS_LEASING";
        const totalSum = sum + Array(duration).fill(0).reduce((a, _, i) => a + sum * rates[Math.min(rates.length - 1, i)] / 100, 0);
        const leasingTotalSum = calculateLeasingTotalSum(sum, duration, rates[0]);
        const paymentsPlan = isLeasing ?
            generateLeasingPayments({
                date: new Date(creationDate),
                duration,
                sumLog,
                leasingRate: rates[0],
                sum,
                preferentialPeriod,
                isLeasingPrepayed,
                isPreferentialRepayment: preferentialRepayment
            })
            :
            generatePayments({ creationDate, duration, rates, sum });

        const thead = [
            "Дата",
            "Оплата",
            "Исполнитель",
            "Статья ДДС",
            "Контрагент",
            "Учетный счет",
            "Сумма",
            "Период",
            "Просрочен",
            "Комментарий"
        ];
        return (
            <Grid container spacing={24}>
                <Grid item className={isLeasing ? "extrawide-column" : "wide-column"}>
                    <Typography variant="h5" align="center">График:</Typography>
                    {isLeasing ?
                        (<Table padding="checkbox">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Дата платежа</TableCell>
                                    <TableCell>Сумма лизингового платежа</TableCell>
                                    <TableCell>Размер выкупной цены</TableCell>
                                    <TableCell>Сумма досрочного выкупа ТС</TableCell>
                                </TableRow >
                            </TableHead>
                            <TableBody>
                                {paymentsPlan.map(({ paymentDate, paymentTotal, paymentCar, paymentBuyout }, i) =>
                                    <TableRow key={i}>
                                        <TableCell>
                                            {i === payments.length ?
                                                <Tooltip title="следующий платеж">
                                                    <Typography variant="subtitle2">
                                                        <FormattedDate value={paymentDate}
                                                                       day="numeric"
                                                                       month="numeric"
                                                                       year="numeric" />
                                                    </Typography>
                                                </Tooltip>
                                                :
                                                <FormattedDate value={paymentDate}
                                                               day="numeric"
                                                               month="numeric"
                                                               year="numeric" />
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {i === payments.length ?
                                                <Tooltip title="следующий платеж">
                                                    <Typography variant="subtitle2">
                                                        <FormattedNumber value={paymentTotal}
                                                                         style={`currency`}
                                                                         currency="RUB"
                                                                         minimumFractionDigits={0} />
                                                    </Typography>
                                                </Tooltip>
                                                :
                                                <FormattedNumber value={paymentTotal}
                                                                 style={`currency`}
                                                                 currency="RUB"
                                                                 minimumFractionDigits={0} />
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {i === payments.length ?
                                                <Tooltip title="следующий платеж">
                                                    <Typography variant="subtitle2">
                                                        <FormattedNumber value={paymentCar}
                                                                         style={`currency`}
                                                                         currency="RUB"
                                                                         minimumFractionDigits={0} />
                                                    </Typography>
                                                </Tooltip>
                                             :
                                                <FormattedNumber value={paymentCar}
                                                                 style={`currency`}
                                                                 currency="RUB"
                                                                 minimumFractionDigits={0} />
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {i === payments.length ?
                                                <Tooltip title="следующий платеж">
                                                    <Typography variant="subtitle2">
                                                        <FormattedNumber value={paymentBuyout}
                                                                         style={`currency`}
                                                                         currency="RUB"
                                                                         minimumFractionDigits={0} />
                                                    </Typography>
                                                </Tooltip>
                                              :
                                              <FormattedNumber value={paymentBuyout}
                                                               style={`currency`}
                                                               currency="RUB"
                                                               minimumFractionDigits={0} />
                                            }
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TableCell>Итого: </TableCell>
                                    <TableCell>
                                        <FormattedNumber value={leasingTotalSum}
                                                         style={`currency`}
                                                         currency="RUB"
                                                         minimumFractionDigits={0} />
                                    </TableCell>
                                    <TableCell>
                                        <FormattedNumber value={sum}
                                                         style={`currency`}
                                                         currency="RUB"
                                                         minimumFractionDigits={0} />
                                    </TableCell>
                                    <TableCell>
                                        &nbsp;
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        </Table>)
                        :
                        (<Table padding="checkbox">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Дата платежа</TableCell>
                                    <TableCell>Сумма платежа</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paymentsPlan.map(({ paymentDate, paymentSum }, i) =>
                                    <TableRow key={i}>
                                        <TableCell>
                                            <FormattedDate value={paymentDate}
                                                           day="numeric"
                                                           month="numeric"
                                                           year="numeric" />
                                        </TableCell>
                                        <TableCell>
                                            <FormattedNumber value={paymentSum}
                                                             style={`currency`}
                                                             currency="RUB"
                                                             minimumFractionDigits={0} />
                                        </TableCell>
                                    </TableRow>
                                )}
                                <TableRow>
                                    <TableCell>
                                        <FormattedDate value={paymentsPlan[paymentsPlan.length - 1].paymentDate}
                                                       day="numeric"
                                                       month="numeric"
                                                       year="numeric" />
                                    </TableCell>
                                    <TableCell>
                                        <FormattedNumber value={sum}
                                                         style={`currency`}
                                                         currency="RUB"
                                                         minimumFractionDigits={0} />

                                        <Typography>(возврат суммы займа)</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TableCell>Итого: </TableCell>
                                    <TableCell>
                                        <FormattedNumber value={totalSum}
                                                         style={`currency`}
                                                         currency="RUB"
                                                         minimumFractionDigits={0} />
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        </Table>)
                    }
                </Grid>
                <Grid item xs>
                    <Typography variant="h5" align="center">Транзакции:</Typography>
                    {transactionsLoaded ? (
                        transactions.length > 0 ?
                            <Fade in={transactionsLoaded}>
                                <Table padding="checkbox">
                                    <TableHead >
                                        <TableRow >
                                            {thead.map((th, i) => <TableCell key={i} >{th}</TableCell>)}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody >
                                        {transactions.map(({
                                            date,
                                            paymentDate,
                                            manager = {},
                                            operation = {},
                                            account,
                                            contract,
                                            counterparty,
                                            sum,
                                            comment,
                                            overdue,
                                            period = {} }, i) => {

                                            const [managerLastname, managerFirstname = " ", managerThirdname = " " ] = (manager.fullname||"").split(" ");

                                            return (
                                                <TableRow key={i}>
                                                    <TableCell>
                                                        <FormattedDate value={date}
                                                                       day="numeric"
                                                                       month="numeric"
                                                                       year="numeric" />
                                                        <br />
                                                        <FormattedTime value={date}
                                                                       hour="numeric"
                                                                       minute="numeric"
                                                                       second="numeric" />
                                                    </TableCell>
                                                    <TableCell >
                                                        <FormattedDate value={paymentDate}
                                                                       day="numeric"
                                                                       month="numeric"
                                                                       year="numeric" />
                                                        <br />
                                                        <FormattedTime value={paymentDate}
                                                                       hour="numeric"
                                                                       minute="numeric"
                                                                       second="numeric" />
                                                    </TableCell>
                                                    <TableCell>
                                                        <InnerLink target="_blank"
                                                                   href={`/user/${manager._id}`}
                                                                   label={`${managerLastname} ${managerFirstname[0]}. ${managerThirdname[0]}.`} />
                                                    </TableCell>
                                                    <TableCell>
                                                        { operation.name }
                                                    </TableCell>
                                                    <TableCell>
                                                        { counterparty ? (counterparty||{}).name : "—" }
                                                    </TableCell>
                                                    <TableCell>
                                                        { account.name }
                                                    </TableCell>
                                                    <TableCell>
                                                        <FormattedNumber value={sum}
                                                                         style={`currency`}
                                                                         currency="RUB"
                                                                         minimumFractionDigits={0} />
                                                    </TableCell>
                                                    <TableCell>
                                                        {overdue}
                                                    </TableCell>
                                                    <TableCell>
                                                        {(operation.alias||"").startsWith("CONTRACT_PROLONGATION") ? `Оплата процентов за период с ${formatDate(new Date(period.date))} по ${formatDate(new Date(+new Date(period.date) + period.duration*24*60*60*1000))}` : ""}
                                                    </TableCell>
                                                    <TableCell>
                                                        {comment}
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        )}
                                    </TableBody >
                                </Table>
                            </Fade> : <Typography>Платежей нет</Typography> )
                        : <React.Fragment><Typography paragraph>Загрузка...</Typography><CircularProgress /></React.Fragment>
                    }
                </Grid>
            </Grid>
        )
    }

}

export default SecurityPayments;



// WEBPACK FOOTER //
// ./src/components/SecurityPayments.js